import React from "react";
import fb from "./../../../imgs/redes_icons-02.png";
import tw from "./../../../imgs/redes_icons-03.png";
import ins from "./../../../imgs/redes_icons-04.png";
import blog from "./../../../imgs/redes_icons_Mesa de trabajo 1.png";
import { Link } from "react-router-dom";
import "./redesButtons.css";

var redesButtons = props => {
  return (
    <div className="redesButtons">
      <div className="redesButtons-item">
        <a href="https://www.facebook.com/AdivorPuebla/" target="_blank">
          <img src={fb} />
        </a>
      </div>
      <div className="redesButtons-item">
        <a href="https://twitter.com/AdivorPuebla" target="_blank">
          <img src={tw} />
        </a>
      </div>
      <div className="redesButtons-item">
        <a href="https://www.instagram.com/adivorpuebla/" target="_blank">
          <img src={ins} />
        </a>
      </div>
      {window.location.hash !== "#/blog" ? (
        <div className="redesButtons-item">
          <Link to="blog">
            <img src={blog} />
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default redesButtons;



// WEBPACK FOOTER //
// ./src/components/function/redes/redesButtons.js